import React from "react";
import { FaBriefcase, FaPlus, FaFileAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export function LeaveBalanceCard({ leavebalance }) {
  const navigate = useNavigate();
  return (
    <div
      className="card shadow-sm h-100 border-0"
      style={{ backgroundColor: "#5151f726" }}
    >
      <div className="card-header bg-transparent border-0 pb-2 d-flex align-items-center gap-2">
        <FaBriefcase className="text-primary mx-1" />
        <h5 className="mb-0 text-primary fw-semibold">Leave Balance</h5>
      </div>
      <div className="card-body d-flex flex-column gap-4">
        <div className="row mb-2">
          <div className="col-lg-6">
            {/* Circular Leave Balance Display */}
            <div className="d-flex justify-content-center">
              <div className="position-relative">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center shadow"
                  style={{
                    width: "96px",
                    height: "96px",
                    background:
                      "linear-gradient(to bottom right, #2c7be5, #569af8)",
                  }}
                >
                  <div className="text-white text-center">
                    <div className="fs-4 fw-bold">
                      {leavebalance?.leaves_remaining}
                    </div>
                    <div className="small">Days</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="col-lg-6">
            <div className="d-flex flex-column gap-2 mt-1">
              <button
                className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                style={{ minHeight: "68px" }}
                onClick={() => {
                  navigate("/school/ess-leave-management");
                }}
              >
                <FaPlus className="me-2" /> Request Leave
              </button>

              {/* <button className="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center mt-1">
                <FaFileAlt className="me-2" /> View All Balance
              </button> */}
            </div>
          </div>
        </div>

        {/* Leave Summary */}
        <div className="bg-white p-3 rounded shadow-sm mt-1">
          <div className="small d-flex justify-content-between">
            <span className="text-muted">Total Leave:</span>
            <span className="fw-medium">{leavebalance?.total_leaves} Days</span>
          </div>
          <div className="small d-flex justify-content-between">
            <span className="text-muted">Used:</span>
            <span className="fw-medium">{leavebalance?.leaves_taken} Days</span>
          </div>
          <div className="small d-flex justify-content-between">
            <span className="text-muted">Remaining:</span>
            <span className="fw-semibold text-primary">
              {Number(leavebalance?.total_leaves) -
                Number(leavebalance?.leaves_taken)}{" "}
              Days
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
